import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import styles from './MileageSimulatorTab.module.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import "../style.css"

const VehicleInfoSection = ({
  // toggleValue,
  // setToggleValue,
  setEnergyEfficiency,
  setDistance,
  filterdata,
  // selectedVehicleType // <-- Add this prop
}) => {
  const { sendReq: fetchData } = useHttp();
  const [efficiencyScore, setEfficiencyScore] = useState('Loading...');
  const [fuelCoastAsPerCity, setFuelCoastAsPerCity] = useState(0)


  useEffect(() => {
    if (filterdata?.CITY?.[0] == "Bangalore") {
      setFuelCoastAsPerCity(6.42)
    }
    else if (filterdata?.CITY?.[0] == "Jammu") {
      setFuelCoastAsPerCity(8.6)
    }
    else if (filterdata?.CITY?.[0] == "Srinagar") {
      setFuelCoastAsPerCity(6.9)
    }
    else if (filterdata?.CITY?.[0] == "Delhi") {
      setFuelCoastAsPerCity(5.27)
    }
    else {
      setFuelCoastAsPerCity(0)
    }

  }, [filterdata?.CITY])

  const [benchmark, setBenchMark] = useState("Community")

  const [data, setData] = useState({
    distance: null,
    energyConsumed: null,
    energyEfficiency: null,
    energyEfficiencyScore: null,
    BenchmarkValue: null,
    vehicleDetails: null
  })

  useEffect(() => {
    setData(prev => ({
      ...prev,
      distance: null,
      energyConsumed: null,
      energyEfficiency: null,
      vehicleDetails: null,
      energyEfficiencyScore: null

    }))
    if (filterdata.VIN_NUM?.length || filterdata.REG_NUM?.length) {
      fetchData(
        {
          url: `${API_URL_MAIN}Ace_simulator/simulator_summary`,
          body: { filterdata }
        },
        (res) => {
          let data = res[0] || {}
          setData(prev => ({
            ...prev,
            distance: data?.Distance_Covered?.value ?? null,
            energyConsumed: data?.Fuel_Consumed?.value ?? null,
            energyEfficiency: data?.Fuel_Efficiency?.value ?? null,
            vehicleDetails: data?.key ?? null

          }))
          setEnergyEfficiency(data?.Fuel_Efficiency?.value ?? null)
          setDistance(data?.Distance_Covered?.value ?? null)
        }
      );

      fetchData(
        {
          url: `${API_URL_MAIN}ace_simulator/simulator_Energy_Efficiency_score`,
          body: { filterdata }
        },
        (res) => {
          let data = res[0] || {}
          setData(prev => ({
            ...prev,
            energyEfficiencyScore: data?.Fuel_Efficiency_Score?.value ?? null

          }))
        }
      );
    }
  }, [filterdata]);

  useEffect(() => {
    setData(prev => ({
      ...prev,
      BenchmarkValue: null
    }))

    if (filterdata.VIN_NUM?.length || filterdata.REG_NUM?.length) {

      let api = benchmark == "Community" ? "simulator_community_benchmark" : "simulator_fleet_benchmark"
      fetchData(
        {
          url: `${API_URL_MAIN}ace_simulator/${api}`,
          body: { filterdata }
        },
        (res) => {
          let data = res[0] || {}
          setData(prev => ({
            ...prev,
            BenchmarkValue: (data?.Community_Benchmark?.value ?? data?.Fleet_benchmark?.value) ?? null

          }))
        }
      );
    }

  }, [filterdata, benchmark]);

  return (
    <div className="row">
      {/* Left Column */}
      <div className="col-lg-12">
        <div className={`bg-white p-4 rounded shadow-sm mb-4 ${styles.vehicleInfoCard}`}>
          <div className="d-flex justify-content-between align-items-start mb-3">
            <div>
              <div className=" text-muted">VIN No. / Chassis No.</div>
              <div className="fw-bold mb-3">
                {data?.vehicleDetails !== null ? <>
                  <div>{data?.vehicleDetails?.vehicleId}</div>
                  <div style={{ fontSize: "12px" }}>{data?.vehicleDetails?.vehicle_registration_number}</div>
                  <small>{data?.vehicleDetails?.PL}</small>{" | "}
                  <small>{data?.vehicleDetails?.LOB}</small>
                </> : <>
                  <div>--</div>
                  <div style={{ fontSize: "12px" }}>--</div>
                  <div>--</div>
                </>}
              </div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <input
                type=""
                className={`form-control text-center fw-bold ${styles.toggleInput}`}
                value={fuelCoastAsPerCity}
                disabled
              // onChange={(e) => setToggleValue(e.target.value)}
              />
              <div className={`d-flex rounded-pill overflow-hidden border ${styles.toggleContainer}`}>
                <button
                  className={` btn-sm px-3 py-1 border-0 fw-semibold ms_btn  ${benchmark === 'Community' ? styles.toggleButtonActive : styles.toggleButtonInactive
                    }`}
                  style={{ color: "white" }}
                  onClick={() => setBenchMark('Community')}
                >
                  Community
                </button>
                <button
                  className={` btn-sm px-3 py-1 border-0 fw-semibold ms_btn ${benchmark === 'Fleet' ? styles.toggleButtonActive : styles.toggleButtonInactive
                    }`}
                  onClick={() => setBenchMark('Fleet')}
                >
                  Fleet
                </button>
              </div>
            </div>
          </div>

          <div className="row text-center">
            <div className="col">
              <div className="small text-muted">Distance Covered</div>
              <div className="fw-bold">{data?.distance !== null ? Math.ceil(data?.distance) + " Kms" : "--"}</div>
            </div>
            <div className="col">
              <div className="small text-muted">Energy Consumed</div>
              <div className="fw-bold">{data?.energyConsumed !== null ? Math.ceil(data?.energyConsumed) + " Wh" : "--"}</div>
            </div>
            <div className="col">
              <div className="small text-muted">Energy Efficiency</div>
              <div className="fw-bold">{data?.energyEfficiency !== null ? data?.energyEfficiency?.toFixed(2) + " Wh/Km" : "--"}</div>
            </div>
            <div className="col">
              <div className="small text-muted">Energy Efficiency Score</div>
              <div className="fw-bold">{data?.energyEfficiencyScore !== null ? data?.energyEfficiencyScore?.toFixed(2) : "--"}</div>
            </div>
            <div className="col">
              <div className="small text-muted">{benchmark + " "} Benchmark</div>
              <div className="fw-bold">{data?.BenchmarkValue !== null ? data?.BenchmarkValue?.toFixed(2) + "" : "--"}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Column */}
      {/* <div className="col-lg-4">
        <div className={`rounded p-4 ${styles.helpSection}`}>
          <div className="d-flex align-items-center mb-3">
            <AlertTriangle className="text-warning me-2" size={20} />
            <h6 className="mb-0 fw-bold">Help Us Improve The Accuracy Of Simulator</h6>
          </div>
          <p className="small mb-3">
            Provide us few details regarding Load, Road and Route condition to help improve the simulator accuracy in <strong>GeoFenced Based Trip details</strong> under <strong>'Add Info'</strong>.
          </p>
          <button
            className={`btn text-white ms_btn_solid_Bus primary border-0 w-100 ${styles.shareButton}`}
          >
            SHARE DETAILS
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default VehicleInfoSection;
